import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { ModalController } from '@ionic/angular';
import { OpenTripPlannerService } from '@ridango/components';
@Component({
    selector: 'gl-select-country-code-modal',
    templateUrl: './select-country-code-modal.component.html',
    styleUrls: ['./select-country-code-modal.component.scss']
})
export class SelectCountryCodeModalComponent extends BaseComponent implements OnInit, OnDestroy {
    public selectedCode;
    @Input() availableCountryCallingCodes = [];
    @Input() selectedCountryCode = '';

    constructor(
        private modalCtrl: ModalController,
        private otpService: OpenTripPlannerService
    ) {
        super();
    }
    ngOnInit(): void {
        this.selectedCode = this.selectedCountryCode;
    }

    handleCountryChange(code) {
        this.selectedCode = code;
    }

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    async handleSaveClick() {
        if (this.selectedCode) {
            await this.modalCtrl.dismiss(this.selectedCode, 'cancel');
        }
    }
}
